module.exports = __webpack_public_path__ + "media/icons/icon-arrow-turquoise-7ff10379.svg";